<template>
  <div>
    <SfMegaMenu :visible="isSearchOpen" :title="$t('Search_results_title')" class="searchResultPage"
      :class="{ mobileResult: isMobile }" @close="closeMenu">
      <transition name="sf-fade" mode="out-in">
        <div v-if="products && products.length > 0" class="search__wrapper-results" key="results">
          <div v-if="categories && categories.length">
            <SfMegaMenuColumn :title="$t('Categories')"
              class="sf-mega-menu-column--pined-content-on-mobile search__categories">
              <template #title="{ title }">
                <SfMenuItem :label="title" @click="megaMenu.changeActive(title)">
                  <template #mobile-nav-icon> &#8203; </template>
                </SfMenuItem>
              </template>
              <SfList>
                <SfListItem v-for="(category, key) in categories" :key="key">
                  <SfMenuItem :label="category.label" :link="localePath(`/c/${category.slug}`)">
                    <template #mobile-nav-icon> &#8203; </template>
                  </SfMenuItem>
                </SfListItem>
              </SfList>
            </SfMegaMenuColumn>
          </div>
          <SfMegaMenuColumn :title="$t('Product suggestions')"
            class="sf-mega-menu-column--pined-content-on-mobile search__results">
            <template #title="{ title }">
              <SfMenuItem :label="title" class="sf-mega-menu-column__header search__header" style="">
                <template #mobile-nav-icon> &#8203; </template>
                <template #label>
                  <div>
                    <div v-if="api !== 'useFacet'">
                      <div>{{ $t('DeliveryCountry') }}</div>
                      <div>
                        <SfSelect v-if="COUNTRIES" v-model="QueryParams.country" :label="''" name="country"
                          class="form__element form__element--half form__select sf-select--underlined"
                          @input="($event) => changeCounry($event)">
                          <template #label></template>
                          <SfSelectOption :value="'all'">
                            {{ $t('All_Country') }}
                          </SfSelectOption>
                          <SfSelectOption v-for="countryOption in COUNTRIES" :key="countryOption.key"
                            :value="countryOption.simple_speech">
                            {{ $t(countryOption.simple_speech) }}
                          </SfSelectOption>
                        </SfSelect>
                      </div>
                    </div>
                    <div v-else>{{ title }}</div>
                  </div>
                </template>
              </SfMenuItem>
            </template>
            <SfScrollable class="results--desktop desktop-only" show-text="" hide-text="">
              <div class="results-listing">
                <div v-for="(product, index) in products" :key="index" @click="closeMenu">
                  <Sf-productCard :score-rating="productGetters.getAverageRating(product)" :reviews-count="7"
                    :image="addBasePath(productGetters.getCoverImage(product))" :alt="productGetters.getName(product)"
                    :title="productGetters.getName(product)"
                    :regular-price="$n(productGetters.getPrice(product).regular, 'currency')" :link="localePath(
                      `/p/${productGetters.getId(
                        product
                      )}/${productGetters.getSlug(
                        product
                      )}`
                    )
                      " :is-in-wishlist="isInWishlist({ product })"
                    @click:wishlist="!isInWishlist({ product }) ? addItemToWishlist({ product }) : removeProductFromWishlist(product)">
                    <template #image>
                      <!--   -->
                      <div class="catImg" @mouseleave="handlerMouseleaveProduct(product)"
                        @mouseover="handlerMouseoverProduct(product)">
                        <nuxt-link :to="localePath(
                          `/p/${productGetters.getId(product)}/${productGetters.getSlug(
                            product
                          )}`
                        )">
                          <template
                            v-if="MouseoverProduct && MouseoverProduct.goodId == product.goodId && MouseoverProduct.images.length > 1">
                            <SfHero class="productHero"
                              :sliderOptions="{ type: 'slider', rewind: true, autoplay: 1000, perView: 1, gap: 0, hoverpause: false }">
                              <template v-for="(image, i) in MouseoverProduct.images">
                                <SfHeroItem :key="i" :image="image.normal"
                                  :nuxtImgConfig="{ modifiers: { format: 'webp' } }">
                                </SfHeroItem>
                              </template>
                              <template #bullets>
                                <div></div>
                              </template>
                              <template #next>
                                <div></div>
                              </template>
                              <template #prev>
                                <div></div>
                              </template>
                            </SfHero>
                          </template>
                          <SfImage v-else
                            :class="{ mouseoverImg: MouseoverProduct && MouseoverProduct.goodId === product.goodId }"
                            :src="product.imageUrl" :alt="product.title" :width="190" :height="190" />
                        </nuxt-link>
                      </div>
                    </template>
                    <!-- <template #regular-price>
                    </template> -->
                    <template #price>
                      <div style="margin: var(--product-card-margin, 0);height:28.8px;align-content: center;">
                        <show-price :regular="productGetters.getPrice(product).regular" />
                      </div>
                    </template>
                    <template #reviews>
                      <div>
                        <div style="display:flex;flex-wrap: wrap;align-items: flex-end;font-size:10pt"
                          v-if="product.deliveryCountries && product.deliveryCountries.length">
                          <!-- <div style="margin-bottom:5px;">{{ $t('DeliveryCountry') }}：</div> -->
                          <div v-for="Countries in product.deliveryCountries"
                            style="margin-right:5px;margin-bottom:5px;">
                            {{ $t(Countries.deliveryCountry) }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </Sf-productCard>
                </div>
              </div>
            </SfScrollable>
            <div class="results--mobile smartphone-only" @click="closeMenu">
              <Sf-productCard v-for="(product, index) in products" :key="index" :regular-price="$n(productGetters.getPrice(product).regular, 'currency')
                " :score-rating="productGetters.getAverageRating(product)" :reviews-count="7"
                :image="addBasePath(productGetters.getCoverImage(product))" :alt="productGetters.getName(product)"
                :title="productGetters.getName(product)"
                :special-price="productGetters.getPrice(product).special ? $n(productGetters.getPrice(product).special, 'currency') : ''"
                :link="localePath(
                  `/p/${productGetters.getId(
                    product
                  )}/${productGetters.getId(product)}/${productGetters.getSlug(
                    product
                  )}`
                )
                  " :is-in-wishlist="isInWishlist({ product })" @click:wishlist="
    !isInWishlist({ product })
      ? addItemToWishlist({ product })
      : removeProductFromWishlist(product)
    ">
                <template #image>
                  <!--   -->
                  <div class="catImg" @mouseleave="handlerMouseleaveProduct(product)"
                    @mouseover="handlerMouseoverProduct(product)">
                    <nuxt-link :to="localePath(
                      `/p/${productGetters.getId(product)}/${productGetters.getSlug(
                        product
                      )}`
                    )">
                      <template
                        v-if="MouseoverProduct && MouseoverProduct.goodId == product.goodId && MouseoverProduct.images.length > 1">
                        <SfHero class="productHero"
                          :sliderOptions="{ type: 'slider', rewind: true, autoplay: 1000, perView: 1, gap: 0, hoverpause: false }">
                          <template v-for="(image, i) in MouseoverProduct.images">
                            <SfHeroItem :key="i" :image="image.normal"
                              :nuxtImgConfig="{ modifiers: { format: 'webp' } }">
                            </SfHeroItem>
                          </template>
                          <template #bullets>
                            <div></div>
                          </template>
                          <template #next>
                            <div></div>
                          </template>
                          <template #prev>
                            <div></div>
                          </template>
                        </SfHero>
                      </template>
                      <SfImage v-else
                        :class="{ mouseoverImg: MouseoverProduct && MouseoverProduct.goodId === product.goodId }"
                        :src="product.imageUrl" :alt="product.title" :width="190" :height="190" />
                    </nuxt-link>
                  </div>
                </template>
                <template #price>
                  <div style="margin: var(--product-card-margin, 0);height:28.8px;align-content: center;">
                    <show-price  :special="productGetters.getPrice(product).special" />
                  </div>
                </template>
                <template #reviews>
                  <div>
                    <div style="display:flex;flex-wrap: wrap;align-items: flex-end;font-size:10pt"
                      v-if="product.deliveryCountries && product.deliveryCountries.length">
                      <!-- <div style="margin-bottom:5px;">{{ $t('DeliveryCountry') }}：</div> -->
                      <div v-for="Countries in product.deliveryCountries" style="margin-right:5px;margin-bottom:5px;">{{
                        $t(Countries.deliveryCountry) }}</div>
                    </div>
                  </div>
                </template>
              </Sf-productCard>
            </div>
            <paginate v-if="totalPageNo > 1" v-model="QueryParams.page" :page-count="totalPageNo" :margin-pages="2"
              :page-range="5" :container-class="'sf-pagination products__pagination'" :activeClass="'current'"
              :page-link-class="'sf-pagination__item'" :prev-link-class="'sf-pagination__item'"
              :next-link-class="'sf-pagination__item'" :break-view-link-class="'break-view-link'" :no-li-surround="true"
              @input="changePageNo" hidePrevNext style="justify-content: flex-end;height:30px;">
            </paginate>
          </SfMegaMenuColumn>
          <div class="action-buttons smartphone-only" v-if="false">
            <SfButton class="action-buttons__button color-light" @click="$emit('close')">{{ $t('Cancel') }}</SfButton>
          </div>
        </div>
        <div v-else key="no-results" class="before-results">
          <SfMegaMenuColumn :title="$t('Product suggestions')"
            class="sf-mega-menu-column--pined-content-on-mobile search__results">
            <template #title="{ title }">
              <SfMenuItem :label="title" class="sf-mega-menu-column__header search__header" style="">
                <template #mobile-nav-icon> &#8203; </template>
                <template #label>
                  <div>
                    <div v-if="api !== 'useFacet'">
                      <div>{{ $t('DeliveryCountry') }}</div>
                      <div>
                        <SfSelect v-if="COUNTRIES" v-model="QueryParams.country" :label="''" name="country"
                          class="form__element form__element--half form__select sf-select--underlined"
                          @input="($event) => changeCounry($event)">
                          <SfSelectOption :value="'all'">
                            {{ $t('All_Country') }}
                          </SfSelectOption>
                          <SfSelectOption v-for="countryOption in COUNTRIES" :key="countryOption.key"
                            :value="countryOption.simple_speech">
                            {{ $t(countryOption.simple_speech) }}
                          </SfSelectOption>
                        </SfSelect>
                      </div>
                    </div>
                    <div v-else>{{ title }}</div>
                  </div>
                </template>
              </SfMenuItem>
            </template>
            <SfImage :src="addBasePath('/error/error.svg')" class="before-results__picture" alt="error" loading="lazy"
              :width="64" :height="64" />
            <template v-if="term">
              <p class="before-results__paragraph">
                {{ $t('search_results_not') }}
              </p>
            </template>
            <template v-else>
              <p class="before-results__paragraph">
                {{ $t('search_results_inputnull') }}
              </p>
              <p class="before-results__paragraph">
                {{ $t('search_results_inputnull2') }}
              </p>
            </template>
            <SfButton class="before-results__button color-secondary smartphone-only" @click="$emit('close')">{{
              $t('Go_back') }}</SfButton>
          </SfMegaMenuColumn>
        </div>
      </transition>
    </SfMegaMenu>
  </div>
</template>
<script>
import {
  SfMegaMenu,
  SfList,
  SfBanner,
  SfProductCard,
  SfScrollable,
  SfMenuItem,
  SfButton,
  SfImage,
  SfBar,
  SfHero,
  SfCarousel,
  SfSelect
} from '@storefront-ui/vue';
import Paginate from '~/components/Paginate';
import showPrice from '~/components/Products/showPrice';
import { ref, watch, computed, onBeforeUnmount } from '@nuxtjs/composition-api';
import { useWishlist, wishlistGetters, productGetters, useGoodsSearch, useGuoJia, useFacet } from '@bee-hole/coms';
import { addBasePath } from '@vue-storefront/core';
import { useUiState } from '~/composables';

export default {
  name: 'SearchResults',
  components: {
    SfMegaMenu,
    SfList,
    SfBanner,
    SfProductCard,
    SfScrollable,
    SfMenuItem,
    SfButton,
    SfImage,
    SfBar,
    SfHero,
    SfCarousel,
    Paginate,
    SfSelect,
    showPrice
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    result: {
      type: Object
    },
    term: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit, root }) {
    const api = ref('searchGoods');
    const { result: catRes, search: searchList } = useFacet('search-goods');
    const { GuoJiaGet, result: countryList } = useGuoJia();
    const COUNTRIES = computed(() => {
      return countryList.value;
    });
    const isSearchOpen = ref(props.visible);
    const { isMobile } = useUiState();
    const QueryParams = ref({
      limit: 10,
      page: 1,
      country: 'all'
    });
    const term = ref(props.term);
    const { search: searchProduct, goodsResult } = useGoodsSearch('search-goods');
    // const totalPageNo = computed(() => Math.ceil((goodsResult.value?.total || 20) / QueryParams.value.limit) || 2);
    const totalPageNo = computed(() => Math.ceil((catRes?.value?.data?.total || 0) / QueryParams.value.limit) || 0);

    const products = computed(() => {
      if (props.result?.products) {
        return productGetters.getImages(props.result?.products);
      } else {
        // 新api参数
        if (api.value === 'useFacet') {
          return productGetters.getImages(catRes?.value?.data?.list);
        } else {
          return productGetters.getImages(goodsResult.value?.list);
        }
        // 旧api参数
      }
    });
    const categories = computed(() => props.result?.categories);
    const { addItem: addItemToWishlist, isInWishlist, removeItem: removeItemFromWishlist, wishlist } = useWishlist();
    const MouseoverProduct = ref();
    // watch(() => props?.result?.products, (newVal) => {
    //   console.log('---------', newVal);
    // });
    const changeCategoryView = () => {
      MouseoverProduct.value = null;
    };
    watch(() => props.visible, (newVal) => {
      isSearchOpen.value = newVal;
      term.value = props.term;
      changeCategoryView();
      if (isSearchOpen.value) {
        GuoJiaGet();
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
        emit('removeSearchResults');
      }
    });
    const closeMenu = () => {
      emit('close');
    };
    const removeProductFromWishlist = (productItem) => {
      const productsInWhishlist = computed(() => wishlistGetters.getItems(wishlist.value));
      const product = productsInWhishlist.value.find(wishlistProduct => wishlistProduct.variant.sku === productItem.sku);
      removeItemFromWishlist({ product });
    };
    onBeforeUnmount(() => {
      emit('close');
    });
    const handlerMouseoverProduct = (product) => {
      MouseoverProduct.value = product;
    };
    const handlerMouseleaveProduct = (product) => {
      if (MouseoverProduct.value?.goodId === product.goodId) {
        MouseoverProduct.value = null;
      }
    };
    const changePageNo = () => {
      const query1 = { page: QueryParams.value.page, limit: QueryParams.value.limit };
      if (QueryParams.value.country && QueryParams.value.country !== 'all') {
        query1.delivery_country = QueryParams.value.country;
      }
      if (api.value !== 'useFacet') {
        query1.title = term.value;
        searchProduct(query1);
      } else {
        query1.q = term.value;
        searchList(query1);
      }
    };
    const changeCounry = ($event) => {
      console.log('changeCounry', $event);
      QueryParams.value.page = 1;
      changePageNo();
    };
    return {
      isSearchOpen,
      productGetters,
      products,
      categories,
      addItemToWishlist,
      isInWishlist,
      removeProductFromWishlist,
      addBasePath,
      closeMenu,
      isMobile,
      MouseoverProduct,
      handlerMouseoverProduct,
      handlerMouseleaveProduct,
      totalPageNo,
      QueryParams,
      changePageNo,
      COUNTRIES,
      changeCounry,
      api
    };
  }
};
</script>
<style lang="scss" scoped>
.searchResultPage {
  position: absolute;
  right: 0;
  left: 0;
  z-index: 3;
  --mega-menu-column-header-margin: var(--spacer-sm) 0 var(--spacer-xl);
  --mega-menu-content-padding: 0;
  --mega-menu-height: auto;

  @include for-desktop {
    --mega-menu-content-padding: var(--spacer-xl) 0;
  }

  &__wrapper-results {
    display: flex;
    flex-direction: column;

    @include for-desktop {
      flex-direction: row;
      flex: 1;
    }
    @include for-mobile{
      padding-top: 0;
      width:100vw;
    }
  }

  &__categories {
    flex: 0 0 220px;
  }

  &__results {
    flex: 1;
  }

  &__header {
    margin-left: var(--spacer-sm);
    @include for-mobile{
      width: calc(100% - (var(--spacer-sm) * 2));
      margin-bottom: 0;
    }
  }

  ::v-deep .sf-bar {
    // display: none;
    --mega-menu-bar-display: flex;
  }

  ::v-deep .sf-mega-menu-column__header {

    // display: none;
    @include for-desktop {
      display: flex;
    }
  }
}

.results {
  &--desktop {
    --scrollable-max-height: 40vh;
  }

  &--mobile {
    // display: flex;
    // flex-wrap: wrap;
    display: grid;
      grid-template-columns: 1fr 1fr;
      gap: calc((100vw - 280px) / 4);
    background: var(--c-white);
    padding: var(--spacer-base) var(--spacer-sm);
    --product-card-max-width: 9rem;
    padding-top: 0;
    height: 40vh;
    overflow: auto;
    justify-content: space-between;
    width: 90%;
    @include for-mobile{
      margin-top: -2rem;
    }
  }
}

.see-all {
  padding: var(--spacer-xl) 0 0 var(--spacer-sm);
}

.action-buttons {
  padding: var(--spacer-xl) var(--spacer-sm) var(--spacer-3xl);
  background: var(--c-white);
  width: 100%;

  &__button {
    width: calc(100% - 32px);
  }
}

.results-listing {
  display: flex;
  flex-wrap: wrap;
  margin-left: var(--spacer-2xs);
}

.result-card {
  margin: var(--spacer-sm) 0;

  @include for-desktop {
    margin: var(--spacer-2xs) 0;
  }
}

.result-card:last-child:nth-child(3n-2) {
  margin-right: auto;
  margin-left: var(--spacer-sm);
}

.result-card:last-child:nth-child(3n-1) {
  margin-right: auto;
  margin-left: var(--spacer-sm);
}

.result-card:last-child:nth-child(2n-1) {
  margin-right: auto;
  margin-left: var(--spacer-sm);
}

.before-results {
  box-sizing: border-box;
  padding: var(--spacer-base) var(--spacer-sm) var(--spacer-2xl);
  width: 100%;
  text-align: center;

  @include for-desktop {
    padding: 0;
  }

  &__picture {
    --image-width: 230px;
    margin-top: var(--spacer-2xl);

    @include for-desktop {
      --image-width: 18.75rem;
      margin-top: var(--spacer-base);
    }
  }

  &__paragraph {
    font-family: var(--font-family--primary);
    font-weight: var(--font-weight--normal);
    font-size: var(--font-size--base);
    color: var(--c-text-muted);
    margin: 0;

    @include for-desktop {
      font-size: var(--font-size--lg);
    }

    &:first-of-type {
      margin: var(--spacer-xl) auto var(--spacer-xs);
    }
  }

  &__button {
    margin: var(--spacer-xl) auto;
    width: 100%;
  }
}
</style>
<style lang="scss">
.search__results {

  .sf-product-card__image,
  .sf-product-card__picture {
    --image-width: 108px;
    --image-height: 120px;
  }
}
.searchResultPage{
  .sf-product-card__title{
    max-width: 190px;
  }
  .search__wrapper-results{
    @include for-mobile {
      padding-top: 0;
      width: 100vw;
    }
  }
}
</style>
